import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9b6756a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ScheduleInfo" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "blank" }, null, -1))
const _hoisted_3 = { class: "content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input-title" }, "巡查时间")
], -1))
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "label-title" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input-title" }, "施工现场进度概述")
], -1))
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "label-title" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input-title" }, "图片")
], -1))
const _hoisted_11 = {
  key: 0,
  class: "row row-img-flex"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "blank" }, null, -1))

import { Approve, projectItem, staffItem } from '@/apis/base'
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()

const type_name = ref('')
const scheduleDetails = ref({
  created_at: '', // 创建时间
  explain: '', // 说明
  patrol_time: '', // 巡查时间
  pics: null, // 图片
  type_id: 0, // 项目类型
  item_id: 0, // 详情id
  approve: {} as Approve,
  project: {} as projectItem,
  staff: {} as staffItem
})
const showBottom = ref(false)

const StaffInfo = ref({
  currentTime: '--', // 当前时间
  company_froms: {
    cf_name: '--'
  },
  name: '--'
})

onMounted(() => {
  type_name.value = router.currentRoute.value.query.type_name.toString()
  scheduleDetails.value = JSON.parse(router.currentRoute.value.query.data.toString())
  console.log('===>', scheduleDetails.value)

  StaffInfo.value.currentTime = scheduleDetails.value.created_at
  StaffInfo.value.name = scheduleDetails.value.staff.name
  StaffInfo.value.company_froms.cf_name = scheduleDetails.value.staff.cf_name
  console.log('===> StaffInfo.value', StaffInfo.value)

  let botton: any = router.currentRoute.value.query.button
  showBottom.value = botton
})

return (_ctx: any,_cache: any) => {
  const _component_base_nav_bar = _resolveComponent("base-nav-bar")!
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_PreviewPicture = _resolveComponent("PreviewPicture")!
  const _component_common_info = _resolveComponent("common-info")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_base_nav_bar, {
      title: _ctx.$route.meta.title,
      "left-text": "返回"
    }, null, 8, ["title"]),
    _createVNode(_component_van_cell_group, null, {
      default: _withCtx(() => [
        _createVNode(_component_van_cell, {
          title: "项目名称",
          value: type_name.value
        }, null, 8, ["value"])
      ]),
      _: 1
    }),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_van_cell_group, { inset: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_van_cell, null, {
            title: _withCtx(() => [
              _hoisted_4
            ]),
            label: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(scheduleDetails.value.patrol_time), 1)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_van_cell, { class: "van-cell-down" }, {
            title: _withCtx(() => [
              _hoisted_7
            ]),
            label: _withCtx(() => [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, _toDisplayString(scheduleDetails.value.explain), 1)
              ])
            ]),
            _: 1
          }),
          (scheduleDetails.value.pics)
            ? (_openBlock(), _createBlock(_component_van_cell, {
                key: 0,
                class: "van-cell-down"
              }, {
                title: _withCtx(() => [
                  _hoisted_10
                ]),
                label: _withCtx(() => [
                  (scheduleDetails.value.pics)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createVNode(_component_PreviewPicture, {
                          imgs: scheduleDetails.value.pics,
                          radius: 5,
                          width: 65,
                          height: 65
                        }, null, 8, ["imgs"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _hoisted_12,
      _createVNode(_component_common_info, { StaffInfo: StaffInfo.value }, null, 8, ["StaffInfo"])
    ])
  ]))
}
}

})